import React from "react";
import PropTypes from "prop-types";

import { assertNonEmptyString, assertOneOf } from "../../internal/contracts";
import { useThemeA } from "../../internal/ThemeAContext";
import { BUTTON_ICON_CLASS, BUTTON_LABEL_CLASS, buttonClassName } from "./buttonStyles";

const INTENTS = ["primary", "secondary", "quiet", "destructive"];

export function ButtonLink({ children, className = "", href, icon = null, intent = "primary", onClick, target }) {
  useThemeA("ButtonLink");
  assertNonEmptyString("ButtonLink", "href", href);
  assertOneOf("ButtonLink", "intent", intent, INTENTS);

  return (
    <a
      data-ak-v2-intent={intent}
      className={`${buttonClassName(intent)} ${className}`.trim()}
      data-ak-v2-component="button-link"
      href={href}
      onClick={onClick}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
    >
      {icon ? <span className={BUTTON_ICON_CLASS} aria-hidden="true">{icon}</span> : null}
      <span className={BUTTON_LABEL_CLASS}>{children}</span>
    </a>
  );
}

ButtonLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  icon: PropTypes.node,
  intent: PropTypes.oneOf(INTENTS),
  onClick: PropTypes.func,
  target: PropTypes.oneOf(["_blank", "_self"]),
};
